// ============================================================
// Owner-module design tokens.
//
// Lifted out of PropertyManagementView so the shared <Segmented> control and
// the shell's own screens resolve the SAME values. Two copies of a palette is
// how a product ends up with three golds.
// ============================================================
import React from 'react';

export const M = {
  gold: '#D6B160',
  goldInk: '#8A6C22',            // gold-toned small text + icons on white
  goldDeep: '#6F5518',
  black: '#000000',
  ink2: 'rgba(0,0,0,0.66)',      // secondary text
  ink3: 'rgba(0,0,0,0.54)',      // labels / eyebrows
  ink4: 'rgba(0,0,0,0.38)',      // faintest text, empty values
  hair: 'rgba(0,0,0,0.10)',      // hairline rules
  wash: 'rgba(0,0,0,0.035)',     // inset panels
  track: 'rgba(0,0,0,0.07)',     // control tracks, meter grooves
  tint: 'rgba(214,177,96,0.13)', // gold chip background
  tintEdge: 'rgba(214,177,96,0.30)',
  // A gold wash over #000 rather than a second colour. Always paired with
  // backgroundColor: '#000' so the stops stay pure alpha-over-black.
  blackGrad: 'linear-gradient(145deg, rgba(214,177,96,0.17) 0%, rgba(214,177,96,0.04) 46%, rgba(214,177,96,0) 72%)',
  okInk: '#0b7a53', okBg: '#d9f5e6',   // functional: rented / paid
};

/**
 * The label above a figure.
 *
 * Was uppercase and letter-spaced, on the reasoning that this is "a hallmark
 * of premium dashboards" — which is exactly the problem: it is the house style
 * of every generated dashboard, and eighteen tracked-out capitals on one
 * screen read as decoration rather than as labels. A statement of account
 * writes its labels in sentence case and lets the FIGURES carry the weight.
 *
 * Sentence case is also materially easier to read at 13.5px, which matters
 * for the audience this module is built for.
 */
export const eyebrow: React.CSSProperties = { letterSpacing: '0.01em' };

// Senior-friendly type scale — nothing meaningful below ~14px, generous
// weights, clear hierarchy. Reused across every tab.
export const T = {
  money: 34, sectionTitle: 19, cardTitle: 18,
  primary: 17, body: 15.5, secondary: 14.5, micro: 13.5,
  statLabel: 13.5, statValue: 20,
};

